import styled from "styled-components";

export const VsiSelectLabel = styled.label`
  color: ${props => props.color || props.theme.textColor};
  font-size: .9rem;
`